import makeStyles from '@mui/styles/makeStyles';
import {find, get, isEmpty} from "lodash";
import React from "react";
import {getSelfAnswers} from "business/quiz";
import QuizAnswerNote from "components/QuizAnswers/QuizAnswerNote";
import SelfAnswerCard from "components/QuizAnswers/SelfAnswerCard";

const useStyles = makeStyles({
  answers: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
});

const QuizAnswerWrapper = ({quizQuestions, quizAnswers, helpText, isLearningHub}) => {
  const classes = useStyles();
  const selfAnswers = getSelfAnswers(isLearningHub, quizAnswers);

  const answerFor = key => find(selfAnswers, answer => answer.questionKey === key);

  return (
    <div className={classes.answers}>
      {!isEmpty(helpText) && <QuizAnswerNote helpText={helpText}/>}
      {get(quizQuestions, 'length') > 0 && quizQuestions.map((question, index) => (
        <SelfAnswerCard
          key={question.key}
          index={index + 1}
          question={question}
          quizAnswer={answerFor(question.key)}
        />
      ))}
    </div>
  );
};

export default QuizAnswerWrapper;
